export const SINGLES = {
  blog: {
    url: '/blog',
    label: 'blog',
  },
}
